import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'simple-header',
  styleUrl: 'simple-header.scss',
})
export class SimpleHeader {
  @Prop() serviceNumber: string;

  render() {
    return (
      <div class="ciHeader">
        <div class="ciHeader-logo">
          <div class="ciHeader-logo-wrapper pigment-wrapper">
            <a href={`${process.env.CI_HOSTNAME}`} aria-label="Custom Ink - Design T-shirts Online">
              <img alt="customink logo - inky" class="ciHeader-logo-image" src={`${process.env.CDN_HOSTNAME}/images/logo-large-horizontal.png`} />
            </a>
            <div class="ciHeader-CustomerSupport">
              <customer-contact serviceNumber={this.serviceNumber}></customer-contact>
              <span class="ciHeader-CustomerSupport-divider" />
              <customer-chat></customer-chat>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
